export default function CIntro() {
  return <h2>C Intro</h2>;
}
